import api from "@/lib/api";

const _seen = new Map();

export function newCorrelationId() {
  return Math.random().toString(36).slice(2, 10);
}

// Fire-and-forget client error telemetry; identical errors throttled to 1/min.
export function reportClientError(payload) {
  try {
    const sig = `${payload.stage}|${payload.dashboard_id || ""}|${payload.widget_id || ""}|${(payload.message || "").slice(0, 80)}`;
    const now = Date.now();
    if (_seen.get(sig) && now - _seen.get(sig) < 60000) return;
    _seen.set(sig, now);
    api.post("/diagnostics/client", {
      ...payload,
      message: String(payload.message || "unknown").slice(0, 500),
      stack: payload.stack ? String(payload.stack).slice(0, 4000) : undefined,
      url: window.location.pathname,
      ua: navigator.userAgent.slice(0, 200),
      correlation_id: payload.correlation_id || newCorrelationId(),
    }).catch(() => {});
  } catch { /* telemetry must never throw */ }
}

// Item 193.19: widget performance telemetry — always logged to console, 10% sampled to server.
// Also feeds the in-session Performance Analyzer panel (Batch 5).
const _perf = new Map();
const _perfSubs = new Set();

export function subscribeWidgetPerf(fn) {
  _perfSubs.add(fn);
  return () => _perfSubs.delete(fn);
}
export function getWidgetPerf() {
  return [..._perf.values()];
}
export function clearWidgetPerf(dashboardId) {
  [..._perf.keys()].forEach((k) => { if (!dashboardId || _perf.get(k)?.dashboardId === dashboardId) _perf.delete(k); });
  _perfSubs.forEach((fn) => { try { fn(); } catch {} });
}

export function logWidgetPerf({ widget, dashboardId, apiMs, rows }) {
  try {
    console.debug(`[widget-perf] ${widget.title || widget.type} (${widget.id}) api=${apiMs}ms rows=${rows}`);
    const prev = _perf.get(widget.id);
    _perf.set(widget.id, {
      widgetId: widget.id, dashboardId,
      title: widget.title || widget.type, type: widget.type,
      apiMs, rows, at: Date.now(), count: (prev?.count || 0) + 1,
    });
    _perfSubs.forEach((fn) => { try { fn(); } catch {} });
    if (Math.random() > 0.1) return;
    api.post("/diagnostics/client", {
      stage: "widget_perf",
      message: `api=${apiMs}ms rows=${rows}`,
      dashboard_id: dashboardId,
      widget_id: widget.id,
      widget_type: widget.type,
      duration_ms: apiMs,
      url: window.location.pathname,
    }).catch(() => {});
  } catch { /* telemetry must never throw */ }
}
